module.exports = __webpack_public_path__ + "static/media/rules.d2594f22.jpg";